import Vue from "vue";
import Router from "vue-router";

import store from "./store"

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'loginController',
    component: resolve => require(['@/views/login.vue'], resolve),
    meta: {
      title: 'login'
    }
  }, {
    path: '/version',
    name: 'versionController',
    component: resolve => require(['@/views/version.vue'], resolve),
    meta: {
      title: 'Version'
    }
  },
  {
    path: '/forgetPassword',
    component: resolve => require(['@/views/forgetPassword.vue'], resolve),
    meta: {
      title: 'forgetPassword'
    }
  },
  {
    path: "/resetPwd",
    component: resolve => require(["@/views/resetPassword.vue"], resolve),
    meta: {
      title: 'resetPassword'
    },
  },
  {
    path: "/main",
    name: "homeController",
    component: resolve => require(["@/views/Home.vue"], resolve),
    children: [{
      path: "homePageController",
      component: resolve => require(["@/views/homePage.vue"], resolve),
      meta: {
        title: 'home',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        }]
      },
    },
    {
      path: "systemPageController",
      component: resolve => require(["@/views/systemPage.vue"], resolve),
      meta: {
        title: 'System',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        }]
      },
    },
    {
      path: "userList",
      component: resolve => require(["@/views/userList.vue"], resolve),
      meta: {
        title: 'userList',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/userList',
          text: 'User listing'
        }
        ]
      },
    },
    {
      path: "userDetail",
      component: resolve => require(["@/views/userDetail.vue"], resolve),
      meta: {
        title: 'userDetail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/userList',
          text: 'User listing'
        },
        {
          to: '/main/userDetail',
          text: 'userDetail'
        }
        ]
      },
    },
    {
      path: "externalUserList",
      component: resolve => require(["@/views/externalUserList.vue"], resolve),
      meta: {
        title: 'External User List',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/externalUserList',
          text: 'External User List'
        }
        ]
      },
    },
    {
      path: "externalUserDetail",
      component: resolve => require(["@/views/externalUserDetail.vue"], resolve),
      meta: {
        title: 'External UserDetail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/externalUserList',
          text: 'External User List'
        },
        {
          to: '/main/externalUserDetail',
          text: 'External UserDetail'
        }
        ]
      },
    },
    {
      path: "publicityList",
      component: resolve => require(["@/views/publicityList.vue"], resolve),
      meta: {
        title: 'News List',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/publicityList',
          text: 'News List'
        }
        ]
      },
    },
    {
      path: "publicityDetail",
      component: resolve => require(["@/views/publicityDetail.vue"], resolve),
      meta: {
        title: 'News Letter Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/publicityList',
          text: 'News List'
        },
        {
          to: '/main/publicityDetail',
          text: 'News Letter Detail'
        }
        ]
      },
    },
    {
      path: "publicitySubDetail",
      component: resolve => require(["@/views/publicitySubDetail.vue"], resolve),
      meta: {
        title: ' J Channel Detail Page',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/publicityList',
          text: 'News List'
        },
        {
          to: '/main/publicityDetail',
          text: 'News Letter Detail'
        },
        {
          to: '/main/publicitySubDetail',
          text: 'News Sub Detail'
        }
        ]
      },
    },
    {
      path: "roleList",
      component: resolve => require(["@/views/roleList.vue"], resolve),
      meta: {
        title: 'roleList',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/roleList',
          text: 'Role listing'
        }
        ]
      },
    },
    {
      path: "roleDetail",
      component: resolve => require(["@/views/roleDetail.vue"], resolve),
      meta: {
        title: 'roleDetail',
        breadcrumbs: [{
          to: '/main/roleDetail',
          text: 'roleDetail'
        }]
      },
    },
    {
      path: "langingPage",
      component: resolve => require(["@/views/landingPage.vue"], resolve),
      meta: {
        title: 'Landing Page Management',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/landingPage',
          text: 'Landing Page Management'
        }
        ]
      },
    },
    {
      path: "pushList",
      component: resolve => require(["@/views/notificationList.vue"], resolve),
      meta: {
        title: 'Push Notification Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/pushList',
          text: 'Push Notification Listing'
        }
        ]
      },
    },
    {
      path: "notificationDetail",
      component: resolve => require(["@/views/notificationDetail.vue"], resolve),
      meta: {
        title: 'Push Notification Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/pushList',
          text: 'Push Notification Listing'
        },
        {
          to: '/main/notificationDetail',
          text: 'Push Notification Detail'
        }
        ]
      },
    },
    {
      path: "newsList",
      component: resolve => require(["@/views/newsList.vue"], resolve),
      meta: {
        title: 'News Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/newsList',
          text: 'News Listing'
        }
        ]
      },
    },
    {
      path: "newsDetail",
      component: resolve => require(["@/views/newsDetail.vue"], resolve),
      meta: {
        title: 'News Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/newsList',
          text: 'News Listing'
        },
        {
          to: '/main/newsDetail',
          text: 'News Detail'
        }
        ]
      },
    },
    {
      path: "eventList",
      component: resolve => require(["@/views/eventList.vue"], resolve),
      meta: {
        title: 'Event Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/eventList',
          text: 'Event Listing'
        }
        ]
      },
    },
    {
      path: "archiveEventList",
      component: resolve => require(["@/views/archiveEventList.vue"], resolve),
      meta: {
        title: 'Archive Event Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/archiveEventList',
          text: 'Archive Event Listing'
        }
        ]
      },
    },
    {
      path: "eventDetail",
      component: resolve => require(["@/views/eventDetail.vue"], resolve),
      meta: {
        title: 'Event Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/eventList',
          text: 'Event Listing'
        },
        {
          to: '/main/eventDetail',
          text: 'Event Detail'
        }
        ]
      },
    },
    {
      path: "tc",
      component: resolve => require(["@/views/termsConditons.vue"], resolve),
      meta: {
        title: 'T&C Managment',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/termsConditons',
          text: 'T&C Managment'
        }
        ]
      },
    },
    {
      path: "privacyPolicy",
      component: resolve => require(["@/views/privacyPolicy.vue"], resolve),
      meta: {
        title: 'Privacy Policy Management',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/privacyPolicy',
          text: 'Privacy Policy Management'
        }
        ]
      },
    },
    {
      path: "aboutJpc",
      component: resolve => require(["@/views/aboutJpc.vue"], resolve),
      meta: {
        title: 'About JPC Management ',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/aboutJpc',
          text: 'About JPC Management'
        }
        ]
      },
    },
    {
      path: "aypInformation",
      component: resolve => require(["@/views/aypInformation.vue"], resolve),
      meta: {
        title: 'AYP Information Managment',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/aypInformation',
          text: 'AYP Information Managment'
        }
        ]
      },
    },
    {
      path: "e-learningList",
      component: resolve => require(["@/views/e-learningList.vue"], resolve),
      meta: {
        title: 'J Channel Category List',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/e-learningList',
          text: 'J Channel Category List'
        }
        ]
      },
    },
    {
      path: "giftDeliveryList",
      component: resolve => require(["@/views/giftDeliveryList.vue"], resolve),
      meta: {
        title: 'Reward Delivery List',
        breadcrumbs: [{
          to: '/main/giftDeliveryList',
          text: 'Reward Delivery List'
        }],
      },
    },
    {
      path: "giftCategoryList",
      component: resolve => require(["@/views/giftCategoryList.vue"], resolve),
      meta: {
        title: 'Rewards Category Maintenance',
        breadcrumbs: [{
          to: '/main/giftCategoryList',
          text: 'Rewards Category Maintenance'
        }],
      },
    },
    {
      path: "giftCategoryDetail",
      component: resolve => require(["@/views/giftCategoryDetail.vue"], resolve),
      meta: {
        title: 'Rewards Category Detail',
        breadcrumbs: [{
          to: '/main/giftCategoryDetail',
          text: 'Rewards Category Detail'
        }],
      },
    },
    {
      path: "publicityCategoryList",
      component: resolve => require(["@/views/publicityCategoryList.vue"], resolve),
      meta: {
        title: 'Publicity Category List',
        breadcrumbs: [{
          to: '/main/publicityCategoryList',
          text: 'Publicity Category List'
        }],
      },
    },
    {
      path: "publicityCategoryDetail",
      component: resolve => require(["@/views/publicityCategoryDetail.vue"], resolve),
      meta: {
        title: 'Publicity Category Detail',
        breadcrumbs: [{
          to: '/main/publicityCategoryDetail',
          text: 'Publicity Category Detail'
        }],
      },
    },
    {
      path: "subCategory",
      component: resolve => require(["@/views/e-learningSubCategory.vue"], resolve),
      meta: {
        title: 'J Channel Sub Category',
        breadcrumbs: [{
          to: '/main/subCategory',
          text: 'J Channel Sub Category'
        }],
      },
    },
    {
      path: "subCategoryDetail",
      component: resolve => require(["@/views/e-learningSubCategoryDetail.vue"], resolve),
      meta: {
        title: 'J Channel Sub Category',
        breadcrumbs: [{
          to: '/main/subCategory',
          text: 'J Channel Sub Category'
        },
        {
          to: '/main/subCategoryDetail',
          text: 'J Channel Sub Category Detail'
        }
        ],
      },
    },
    {
      path: "e-learningDetail",
      component: resolve => require(["@/views/e-learningDetail.vue"], resolve),
      meta: {
        title: 'J Channel Category Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/e-learningList',
          text: 'J Channel Category List'
        },
        {
          to: '/main/e-learningDetail',
          text: 'J Channel Category Detail'
        }
        ]
      },
    },
    {
      path: "e-learningSubDetail",
      component: resolve => require(["@/views/e-learningSubDetail.vue"], resolve),
      meta: {
        title: ' J Channel Detail Page',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/e-learningList',
          text: 'J Channel Category List'
        },
        {
          to: '/main/e-learningDetail',
          text: 'J Channel Category Detail'
        },
        {
          to: '/main/e-learningSubDetail',
          text: ' J Channel Detail Page'
        }
        ]
      },
    },
    {
      path: "newsLetter",
      component: resolve => require(["@/views/newsLetterList.vue"], resolve),
      meta: {
        title: 'News Letter Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/newsLetter',
          text: 'News Letter Listing'
        }
        ]
      },
    },
    {
      path: "newsLetterDetail",
      component: resolve => require(["@/views/newsLetterDetail.vue"], resolve),
      meta: {
        title: 'News Letter Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/newsLetter',
          text: 'News Letter Listing'
        },
        {
          to: '/main/newsLetterDetail',
          text: 'News Letter Detail'
        }
        ]
      },
    },
    {
      path: "staffUser",
      component: resolve => require(["@/views/staffUserList.vue"], resolve),
      meta: {
        title: 'Staff User Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/staffUser',
          text: 'Staff User Listing'
        }
        ]
      },
    },
    {
      path: "staffUserDetail",
      component: resolve => require(["@/views/staffUserDetail.vue"], resolve),
      meta: {
        title: 'Staff User Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/staffUser',
          text: 'Staff User Listing'
        },
        {
          to: '/main/staffUserDetail',
          text: 'Staff User Detail'
        }
        ]
      },
    },
    {
      path: "rewardsDetail",
      component: resolve => require(["@/views/loyaltyDescription.vue"], resolve),
      meta: {
        title: 'Rewards Description',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/rewardsDetail',
          text: 'Rewards Description'
        }
        ]
      },
    },
    {
      path: "rewards",
      component: resolve => require(["@/views/rewardsList.vue"], resolve),
      meta: {
        title: 'Reward Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/rewards',
          text: 'Reward Listing'
        }
        ]
      },
    },
    {
      path: "rewardDetail",
      component: resolve => require(["@/views/rewardsDetail.vue"], resolve),
      meta: {
        title: 'Reward Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/rewards',
          text: 'Reward Listing'
        },
        {
          to: '/main/rewardDetail',
          text: 'Reward Detail'
        }
        ]
      },
    },
    {
      path: "imageBanner",
      component: resolve => require(["@/views/bannerList.vue"], resolve),
      meta: {
        title: 'Banner Listing',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/imageBanner',
          text: 'Banner Listing'
        }
        ]
      },
    },
    {
      path: "bannerDetail",
      component: resolve => require(["@/views/bannerDetail.vue"], resolve),
      meta: {
        title: 'Banner Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/imageBanner',
          text: 'Banner Listing'
        },
        {
          to: '/main/bannerDetail',
          text: 'Banner Detail'
        }
        ]
      },
    },
    {
      path: "auditLog",
      component: resolve => require(["@/views/auditLog.vue"], resolve),
      meta: {
        title: 'Audit Log',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/auditLog',
          text: 'Audit Log'
        }
        ]
      },
    },
    {
      path: "stemupUpload",
      component: resolve => require(["@/views/stemupUpload.vue"], resolve),
      meta: {
        title: 'EO Form Upload',
        breadcrumbs: [{
          to: '/main/stemupUpload',
          text: 'EO Form Upload'
        }]
      },
    },

    {
      path: "onlineSubmission",
      component: resolve => require(["@/views/onlineSubmission.vue"], resolve),
      meta: {
        title: 'Online Submission',
        breadcrumbs: [{
          to: '/main/onlineSubmission',
          text: 'Online Submission'
        }]
      },
    },
    {
      path: "physicalSubmission",
      component: resolve => require(["@/views/physicalSubmission.vue"], resolve),
      meta: {
        title: 'Physical Submission',
        breadcrumbs: [{
          to: '/main/physicalSubmission',
          text: 'Physical Submission'
        }],
      },
    },
    {
      path: "sideMenu1",
      component: resolve => require(["@/views/sideMenu.vue"], resolve),
      meta: {
        title: 'Side Menu',
        breadcrumbs: [{
          to: '/main/onlineSubmission',
          text: 'Online Submission'
        },
        {
          to: '/main/sideMenu',
          text: 'Side Menu'
        }
        ]
      },
    },
    {
      path: "sideMenu2",
      component: resolve => require(["@/views/sideMenu.vue"], resolve),
      meta: {
        title: 'Side Menu',
        breadcrumbs: [{
          to: '/main/physicalSubmission',
          text: 'Physical Submission'
        },
        {
          to: '/main/sideMenu',
          text: 'Side Menu'
        }
        ]
      },
    },
    {
      path: "sideMenu3",
      component: resolve => require(["@/views/sideMenu.vue"], resolve),
      meta: {
        title: 'Side Menu',
        breadcrumbs: [{
          to: '/main/batchSubmission',
          text: 'Batch Submission'
        },
        {
          to: '/main/sideMenu',
          text: 'Side Menu'
        }
        ]
      },
    },
    {
      path: "quizResult",
      component: resolve => require(["@/views/quizResult.vue"], resolve),
      meta: {
        title: 'J Channel Quiz',
        breadcrumbs: [{
          to: '/main/quizResult',
          text: 'J Channel Quiz'
        }]
      },
    },
    {
      path: "giftStore",
      component: resolve => require(["@/views/giftStore.vue"], resolve),
      meta: {
        title: 'Redemption Centre Maintenance',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftStore',
          text: 'Redemption Centre Maintenance'
        }]
      },
    },
    {
      path: "giftStoreDetail",
      component: resolve => require(["@/views/giftStoreDetail.vue"], resolve),
      meta: {
        title: 'Redemption Centre Maintenance Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftStore',
          text: 'Redemption Centre Maintenance'
        },
        {
          to: '/main/giftStoreDetail',
          text: 'Redemption Centre Maintenance Detail'
        }
        ]
      },
    },
    {
      path: "giftInventoryLog",
      component: resolve => require(["@/views/giftInventoryLog.vue"], resolve),
      meta: {
        title: 'Inventory Maintenance',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftInventoryLog',
          text: 'Inventory Maintenance'
        }]
      },
    },
    {
      path: "giftInventoryLogDetail",
      component: resolve => require(["@/views/giftInventoryLogDetail.vue"], resolve),
      meta: {
        title: 'Inventory Maintenance Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftInventoryLog',
          text: 'Inventory Maintenance'
        },
        {
          to: '/main/giftInventoryLogDetail',
          text: 'Inventory Maintenance Detail'
        }
        ]
      },
    },
    {
      path: "giftRequest",
      component: resolve => require(["@/views/giftRequest.vue"], resolve),
      meta: {
        title: 'Redemption Request',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftRequest',
          text: 'Redemption Request'
        }]
      },
    },
    {
      path: "giftRequestDetail",
      component: resolve => require(["@/views/giftRequestDetail.vue"], resolve),
      meta: {
        title: 'Redemption Request Detail',
        breadcrumbs: [{
          to: '/main/homePageController',
          text: 'HomePage'
        },
        {
          to: '/main/giftRequest',
          text: 'Redemption Request'
        },
        {
          to: '/main/giftRequestDetail',
          text: 'Redemption Request Detail'
        }
        ]
      },
    },
    {
      path: "hsbconlineSubmission",
      component: resolve => require(["@/views/hsbconlineSubmission.vue"], resolve),
      meta: {
        title: 'HSBC Online Submission',
        breadcrumbs: [{
          to: '/main/hsbconlineSubmission',
          text: 'HSBC Online Submission'
        }]
      },
    },
    {
      path: "batchSubmission",
      component: resolve => require(["@/views/batchSubmission.vue"], resolve),
      meta: {
        title: 'Batch Submission',
        breadcrumbs: [{
          to: '/main/batchSubmission',
          text: 'Batch Submission'
        }]
      },
    },
    {
      path: "hsbcstemupUpload",
      component: resolve => require(["@/views/hsbcstemupUpload.vue"], resolve),
      meta: {
        title: 'EO Form Upload',
        breadcrumbs: [{
          to: '/main/hsbcstemupUpload',
          text: 'EO Form Upload'
        }]
      },
    },
    {
      path: "judgeAccount",
      component: resolve => require(["@/views/judgeAccount.vue"], resolve),
      meta: {
        title: 'Judge Account',
        breadcrumbs: [{
          to: '/main/judgeAccount',
          text: 'Judge Account'
        }]
      },
    },
    {
      path: "editJudgeAccount",
      component: resolve => require(["@/views/editJudgeAccount.vue"], resolve),
      meta: {
        title: 'Judge Account',
        breadcrumbs: [{
          to: '/main/judgeAccount',
          text: 'Judge Account'
        },
        {
          to: '/main/editJudgeAccount',
          text: 'Edit Judge Account'
        }
        ]
      },
    },
    {
      path: "hsbcJudgeAccount",
      component: resolve => require(["@/views/hsbcJudgeAccount.vue"], resolve),
      meta: {
        title: 'HSBC Judge Account',
        breadcrumbs: [{
          to: '/main/hsbcJudgeAccountt',
          text: 'HSBC Judge Account'
        }]
      },
    },
    {
      path: "hsbcEditJudgeAccount",
      component: resolve => require(["@/views/hsbcEditJudgeAccount.vue"], resolve),
      meta: {
        title: 'HSBC Edit Judge Account',
        breadcrumbs: [{
          to: '/main/hsbcJudgeAccount',
          text: 'HSBC Judge Account'
        },
        {
          to: '/main/hsbcEditJudgeAccount',
          text: 'HSBC Edit Judge Account'
        }
        ]
      },
    },
    {
      path: "assignEntries",
      component: resolve => require(["@/views/assignEntries.vue"], resolve),
      meta: {
        title: 'Assign Entries',
        breadcrumbs: [{
          to: '/main/assignEntries',
          text: 'Assign Entries'
        }]
      },
    },
    {
      path: "hsbcAssignEntries",
      component: resolve => require(["@/views/hsbcAssignEntries.vue"], resolve),
      meta: {
        title: 'HSBC Assign Entries',
        breadcrumbs: [{
          to: '/main/hsbcAssignEntries',
          text: 'HSBC Assign Entries'
        }]
      },
    },
    {
      path: "assignJudges",
      component: resolve => require(["@/views/assignJudges.vue"], resolve),
      meta: {
        title: 'Assign Judges',
        breadcrumbs: [{
          to: '/main/assignJudges',
          text: 'Assign Judges'
        }]
      },
    },
    {
      path: "hsbcAssignJudges",
      component: resolve => require(["@/views/hsbcAssignJudges.vue"], resolve),
      meta: {
        title: 'HSBC Assign Judges',
        breadcrumbs: [{
          to: '/main/hsbcAssignJudges',
          text: 'HSBC Assign Judges'
        }]
      },
    },
    {
      path: "overallStatus",
      component: resolve => require(["@/views/overallStatus.vue"], resolve),
      meta: {
        title: 'Overall Status',
        breadcrumbs: [{
          to: '/main/overallStatus',
          text: 'Overall Status'
        }]
      },
    },
    {
      path: "overallStatusDetail",
      component: resolve => require(["@/views/overallStatusDetail.vue"], resolve),
      meta: {
        title: 'Overall Status Detail',
        breadcrumbs: [{
          to: '/main/overallStatus',
          text: 'Overall Status'
        },
        {
          to: '/main/overallStatusDetail',
          text: 'Overall Status Detail'
        }
        ]
      },
    },
    {
      path: "overallStatusEntryDetail",
      component: resolve => require(["@/views/overallStatusEntryDetail.vue"], resolve),
      meta: {
        title: 'Overall Status Detail',
        breadcrumbs: [{
          to: '/main/overallStatus',
          text: 'Overall Status'
        },
        {
          to: '/main/overallStatusDetail',
          text: 'Overall Status Detail'
        },
        {
          to: '/main/overallStatusEntryDetail',
          text: 'Overall Status Entry Detail'
        }
        ]
      },
    },
    {
      path: "hsbcOverallStatus",
      component: resolve => require(["@/views/hsbcOverallStatus.vue"], resolve),
      meta: {
        title: 'HSBC Overall Status',
        breadcrumbs: [{
          to: '/main/hsbcOverallStatus',
          text: 'HSBC Overall Status'
        }]
      },
    },
    {
      path: "hsbcOverallStatusDetail",
      component: resolve => require(["@/views/hsbcOverallStatusDetail.vue"], resolve),
      meta: {
        title: 'HSBC Overall Status Detail',
        breadcrumbs: [{
          to: '/main/hsbcOverallStatus',
          text: 'HSBC Overall Status'
        },
        {
          to: '/main/hsbcOverallStatusDetail',
          text: 'HSBC Overall Status Detail'
        }
        ]
      },
    },
    {
      path: "hsbcOverallStatusEntryDetail",
      component: resolve => require(["@/views/hsbcOverallStatusEntryDetail.vue"], resolve),
      meta: {
        title: 'HSBC Overall Status Detail',
        breadcrumbs: [{
          to: '/main/hsbcOverallStatus',
          text: 'HSBC Overall Status'
        },
        {
          to: '/main/hsbcOverallStatusDetail',
          text: 'HSBC Overall Status Detail'
        },
        {
          to: '/main/hsbcOverallStatusEntryDetail',
          text: 'HSBC Overall Status Entry Detail'
        }
        ]
      },
    },
    {
      path: "judgeHistory",
      component: resolve => require(["@/views/judgeHistory.vue"], resolve),
      meta: {
        title: 'Judge History',
        breadcrumbs: [{
          to: '/main/judgeHistory',
          text: 'Judge History'
        }]
      },
    },
    {
      path: "hsbcJudgeHistory",
      component: resolve => require(["@/views/hsbcJudgeHistory.vue"], resolve),
      meta: {
        title: 'HSBC Judge History',
        breadcrumbs: [{
          to: '/main/hsbcJudgeHistory',
          text: 'HSBC Judge History'
        }]
      },
    },
    {
      path: "partnershipList",
      component: resolve => require(["@/views/partnershipList.vue"], resolve),
      meta: {
        title: 'Partnership List',
        breadcrumbs: [{
          to: '/main/partnershipList',
          text: 'Partnership List'
        }]
      },
    },
    {
      path: "editPartnership",
      component: resolve => require(["@/views/editPartnership.vue"], resolve),
      meta: {
        title: 'Edit Partnership',
        breadcrumbs: [{
          to: '/main/partnershipList',
          text: 'Partnership List'
        },
        {
          to: '/main/editPartnership',
          text: 'Edit Partnership'
        }
        ]
      },
    },
    {
      path: "contactUsList",
      component: resolve => require(["@/views/contactUsList.vue"], resolve),
      meta: {
        title: 'Contact Us List',
        breadcrumbs: [{
          to: '/main/contactUsList',
          text: 'Contact Us List'
        }]
      },
    },
    {
      path: "editContactUs",
      component: resolve => require(["@/views/editContactUs.vue"], resolve),
      meta: {
        title: 'Edit Contact Us',
        breadcrumbs: [{
          to: '/main/contactUsList',
          text: 'Contact Us List'
        },
        {
          to: '/main/editContactUs',
          text: 'Edit Contact Us'
        }
        ]
      },
    },
    {
      path: "websiteMenuList",
      component: resolve => require(["@/views/websiteMenuList.vue"], resolve),
      meta: {
        title: 'Website Menu List',
        breadcrumbs: [{
          to: '/main/websiteMenuList',
          text: 'Website Menu List'
        }]
      },
    },
    {
      path: "editWebsiteMenu",
      component: resolve => require(["@/views/editWebsiteMenu.vue"], resolve),
      meta: {
        title: 'Edit Website Menu',
        breadcrumbs: [{
          to: '/main/websiteMenuList',
          text: 'Website Menu List'
        },
        {
          to: '/main/editWebsiteMenu',
          text: 'Edit Website Menu'
        }
        ]
      },
    },
    {
      path: "awardsList",
      component: resolve => require(["@/views/awardsList.vue"], resolve),
      meta: {
        title: 'Awards List',
        breadcrumbs: [{
          to: '/main/awardsList',
          text: 'Awards List'
        }]
      },
    },
    {
      path: "challengeCorner",
      component: resolve => require(["@/views/bannerManagement.vue"], resolve),
      meta: {
        title: 'Banner Management',
        breadcrumbs: [{
          to: '/main/bannerManagement',
          text: 'Banner Management'
        }]
      },
    },
    {
      path: "schoolUser",
      component: resolve => require(["@/views/schoolUser.vue"], resolve),
      meta: {
        title: 'School User List',
        breadcrumbs: [{
          to: '/main/schoolUser',
          text: 'School User List'
        }]
      },
    },
    {
      path: "schoolDetail",
      component: resolve => require(["@/views/schoolDetail.vue"], resolve),
      meta: {
        title: 'School User List',
        breadcrumbs: [{
          to: '/main/schoolUser',
          text: 'School User List'
        },
        {
          to: "/main/schoolDetail",
          text: 'School User Detail'

        }
        ]
      },
    },
    {
      path: "schoolImgBanner",
      component: resolve => require(["@/views/schoolImgBanner.vue"], resolve),
      meta: {
        title: 'School Img Banner',
        breadcrumbs: [{
          to: '/main/schoolImgBanner',
          text: 'School Img Banner'
        }
        ]
      },
    },
    {
      path: "schoolImgDetail",
      component: resolve => require(["@/views/schoolImgDetail.vue"], resolve),
      meta: {
        title: 'School User List',
        breadcrumbs: [{
          to: '/main/schoolImgBanner',
          text: 'School Img Banner'
        },
        {
          to: "/main/schoolImgDetail",
          text: 'School Img Detail'
        }
        ]
      },
    },
    {
      path: "schoolResourcesCategory",
      component: resolve => require(["@/views/schoolResourcesCategoryList.vue"], resolve),
      meta: {
        title: 'School Resources Category List',
        breadcrumbs: [{
          to: '/main/schoolResourcesCategory',
          text: 'School Resources Category List'
        }
        ]
      },
    },
    {
      path: "schoolResourcesCategoryDetail",
      component: resolve => require(["@/views/schoolResourcesCategoryDetail.vue"], resolve),
      meta: {
        title: 'School Resources Category List',
        breadcrumbs: [{
          to: '/main/schoolResourcesCategory',
          text: 'School Resources Category List'
        },
        {
          to: "/main/schoolResourcesCategoryDetail",
          text: 'School Resources Category Detail'
        }
        ]
      },
    },
    {
      path: "schoolResources",
      component: resolve => require(["@/views/schoolResourcesList.vue"], resolve),
      meta: {
        title: 'School Resources List',
        breadcrumbs: [{
          to: '/main/schoolResources',
          text: 'School Resources List'
        }
        ]
      },
    },
    {
      path: "schoolResourcesDetail",
      component: resolve => require(["@/views/schoolResourcesDetail.vue"], resolve),
      meta: {
        title: 'School Resources List',
        breadcrumbs: [{
          to: '/main/schoolResources',
          text: 'School Resources List'
        },
        {
          to: "/main/schoolResourcesDetail",
          text: 'School Resources Detail'
        }
        ]
      },
    },
    {
      path: "schoolEvent",
      component: resolve => require(["@/views/schoolEventsListing.vue"], resolve),
      meta: {
        title: 'School Event List',
        breadcrumbs: [{
          to: '/main/schoolEvent',
          text: 'School Event List'
        }
        ]
      },
    },
    {
      path: "schoolEventDetail",
      component: resolve => require(["@/views/schoolEventDetail.vue"], resolve),
      meta: {
        title: 'School Event Detail',
        breadcrumbs: [{
          to: '/main/schoolEvent',
          text: 'School Event List'
        },
        {
          to: "/main/schoolEventDetail",
          text: 'School Event Detail'
        }
        ]
      },
    },
    {
      path: "archiveSchoolEvent",
      component: resolve => require(["@/views/archiveSchoolEvent.vue"], resolve),
      meta: {
        title: 'Archive School Event',
        breadcrumbs: [{
          to: '/main/archiveSchoolEvent',
          text: 'School Event List'
        }
        ]
      },
    },
    {
      path: "rewardsConfiguration",
      component: resolve => require(["@/views/rewardsConfiguration.vue"], resolve),
      meta: {
        title: 'Rewards Configuration',
        breadcrumbs: [{
          to: '/main/rewardsConfiguration',
          text: 'Rewards Configuration'
        }
        ]
      }
    },
    {
      path: "eventRequestDetails",
      component: resolve => require(["@/views/eventRequestDetails.vue"], resolve),
      meta: {
        title: 'Event Request Details ',
        breadcrumbs: [{
          to: '/main/schoolRequest',
          text: 'Event Request'
        },
        {
          to: "/main/eventRequestDetails",
          text: 'Event Request Details '
        }

        ]
      },
    },
    {
      path: "confirmedEventDetail",
      component: resolve => require(["@/views/confirmedEventDetail.vue"], resolve),
      meta: {
        title: 'Confirmed Event Detail',
        breadcrumbs: [{
          to: '/main/schoolEventsListing',
          text: 'School Events Listing'
        },
        {
          to: "/main/confirmedEventDetail",
          text: 'Confirmed Event Detail '
        }

        ]
      },
    },
    {
      path: "schoolEventsListing",
      component: resolve => require(["@/views/schoolEventsListing.vue"], resolve),
      meta: {
        title: 'School Events Listing',
        breadcrumbs: [{
          to: '/main/schoolEventsListing',
          text: 'School Events Listing'
        }
        ]
      },
    },
    {
      path: "promotionEventDetail",
      component: resolve => require(["@/views/promotionEventDetail.vue"], resolve),
      meta: {
        title: 'Promotion Event Detail',
        breadcrumbs: [{
          to: '/main/schoolEventsListing',
          text: 'School Events Listing'
        },
        {
          to: "/main/promotionEventDetail",
          text: 'Promotion Event Detail '
        }

        ]
      },
    },
    {
      path: "calendar",
      component: resolve => require(["@/views/schoolCalendar.vue"], resolve),
      meta: {
        title: 'School Calendar',
        breadcrumbs: [{
          to: '/main/schoolCalendar',
          text: 'School Calendar'
        }

        ]
      },
    },
    {
      path: "schoolRequest",
      component: resolve => require(["@/views/schoolRequestList.vue"], resolve),
      meta: {
        title: 'Event Request',
        breadcrumbs: [{
          to: '/main/schoolRequestList',
          text: 'Event Request'
        }

        ]
      },
    },
    {
      path: "memberCommentBoxList",
      component: resolve => require(["@/views/memberCommentBoxList.vue"], resolve),
      meta: {
        title: 'Member Comment',
        breadcrumbs: [
          {
            to: '/main/homePageController',
            text: 'HomePage'
          },
          {
            to: '/main/memberCommentBoxList',
            text: 'Member Comment'
          }

        ]
      },
    },
    {
      path: "memberCommentBoxDetail",
      component: resolve => require(["@/views/memberCommentBoxDetail.vue"], resolve),
      meta: {
        title: 'Confirmed Event Detail',
        breadcrumbs: [{
          to: '/main/memberCommentBoxList',
          text: 'Member Comment'
        },
        {
          to: "/main/memberCommentBoxDetail",
          text: 'Member Comment Detail '
        }

        ]
      },
    },
    {
      path: "memberCommentBoxDistrictEmailList",
      component: resolve => require(["@/views/memberCommentBoxDistrictEmailList.vue"], resolve),
      meta: {
        title: 'District Email',
        breadcrumbs: [
          {
            to: '/main/homePageController',
            text: 'HomePage'
          },
          {
            to: '/main/memberCommentBoxDistrictEmailList',
            text: 'District Email'
          }

        ]
      },
    },
    {
      path: "memberCommentBoxExport",
      component: resolve => require(["@/views/memberCommentBoxExport.vue"], resolve),
      meta: {
        title: 'Member Feedback Export',
        breadcrumbs: [
          {
            to: '/main/homePageController',
            text: 'HomePage'
          },
          {
            to: '/main/memberCommentBoxExport',
            text: 'Member Feedback Export'
          }

        ]
      },
    },
    
    {
      path: "userStampUpdateLogList",
      component: resolve => require(["@/views/userStampUpdateLogList.vue"], resolve),
      meta: {
        title: 'Adjustment List',
        breadcrumbs: [
          {
            to: '/main/homePageController',
            text: 'HomePage'
          },
          {
            to: '/main/userStampUpdateLogList',
            text: 'Adjustment List'
          }

        ]
      },
    },
    {
      path: "userStampUpdateLogDetail",
      component: resolve => require(["@/views/userStampUpdateLogDetail.vue"], resolve),
      meta: {
        title: 'Adjustment Detail',
        breadcrumbs: [
          {
            to: '/main/homePageController',
            text: 'HomePage'
          },
          {
            to: '/main/userStampUpdateLogList',
            text: 'Adjustment List'
          },
          {
            to: '/main/userStampUpdateLogList',
            text: 'Adjustment Detail'
          }

        ]
      },
    },
    {
      path: "schoolContactUs",
      component: resolve => require(["@/views/schoolContactUs.vue"], resolve),
      meta: {
        title: 'Contact Us',
        breadcrumbs: [{
          to: '/main/schoolContactUs',
          text: 'Contact Us'
        }

        ]
      },
    },
    {
      path: "schoolContactUsDetail",
      component: resolve => require(["@/views/schoolContactUsDetail.vue"], resolve),
      meta: {
        title: 'Contact Us Detail',
        breadcrumbs: [{
          to: '/main/schoolContactUsDetail',
          text: 'Contact Us Detail'
        }

        ]
      },
    },

      // {
      //   path: "archiveSchoolEventDetail",
      //   component: resolve => require(["@/views/archiveSchoolEventDetail.vue"], resolve),
      //   meta: {
      //     title: 'Archive School Event',
      //     breadcrumbs: [{
      //       to: '/main/archiveSchoolEvent',
      //       text: 'School Event List'
      //     },
      //     {
      //       to: "/main/archiveSchoolEventDetail",
      //       text: 'Archive School EventDetail'
      //     }
      //     ]
      //   },
      // },
    ]
  },
  ],
})

export default router